import "./Login.css";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import { jwtDecode } from "jwt-decode";
import { Toast } from "primereact/toast";
import {
  postAPICall,
  setToastRef,
  showErrorToast,
  showToast,
} from "../Api/Api";
import { GoogleLogin } from "@react-oauth/google";

import packageInfo from "../../package.json";
export default function Login(props) {
  const [Pusername, setUsername] = useState("");
  const [Ppassword, setPassword] = useState("");
  const [LoginResponsemessage, setLoginResponsemessage] = useState("");
  let navigate = useNavigate();
  //password empty
  const [RequiredValidation, setRequiredValidation] = useState("");
  const [error, setError] = useState("");
  //remember me
  const [rememberMe, setRememberMe] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [tvAppUrl, setTvAppUrl] = useState(null);
  const toast = useRef(null);
  useEffect(() => {
    setToastRef(toast.current);
  }, []);
  //  const history =useHistory ();
  const updateUsername = (e) => {
    setUsername(e.target.value);
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setError("UserName is required.");
    } else {
      setError("");
    }
  };
  useEffect(() => {
    GetTVAppDetails();
  }, []);
  const GetTVAppDetails = async () => {
    const response = await postAPICall("api/TVAppDetails/GetTvAppDetails");
    if (response) {
      setTvAppUrl(response?.data?.AppUrl);
    }
  };
  const updatepassword = (e) => {
    setPassword(e.target.value);
    const inputValue = e.target.value;
    //check textbox  empty
    setRequiredValidation(inputValue);

    if (inputValue.trim() === "") {
      setError("Password is required.");
    } else {
      setError("");
    }
  };
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const requestBody = {
    Pusername: Pusername,
    Ppassword: Ppassword,
  };
  const handlePost = async () => {
    try {
      localStorage.clear();
      const response = await postAPICall("api/LoginJwt/UserLogin", requestBody);
      if (response?.data.Message == true) {
        console.log("respons22e", response);
        localStorage.setItem("logginuser", Pusername);
        localStorage.setItem("JWtAccessToken", response.data.Token.Token);
        localStorage.setItem(
          "JWTRefreshToken",
          response.data.Token.RefreshToken
        );
        localStorage.setItem("GetUserId", response.data.UserData[0].UserID); //JSON.stringify(Pusername));
        localStorage.setItem(
          "Loginusertype",
          response.data.UserData[0].UserType
        );
        if (response.data.UserData[0].UserType == "Administration") {
          navigate("/ChannelPopup");
        } else {
          navigate("/ChannelPopup");
        }
      } else {
        if (response == undefined) {
          showErrorToast("Invalid Credential !!");
        }
        setLoginResponsemessage(response?.data.Message);
      }
    } catch (error) {}
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setRememberMe(false);
  };
  const responseGoogle = async (gauthresponse) => {
    try {
      var userObject = jwtDecode(gauthresponse.credential);
      const requestBody = {
        PuserName: userObject.name,
        Mailaddress: userObject.email,
      };

      localStorage.clear();
      const response = await postAPICall(
        "api/LoginJwt/GAuthLogin",
        requestBody
      );

      if (response.data) {
        localStorage.setItem("logginuser", Pusername);
        localStorage.setItem("JWtAccessToken", response.data.Token.Token);
        localStorage.setItem(
          "JWTRefreshToken",
          response.data.Token.RefreshToken
        );
        localStorage.setItem("GetUserId", response.data.UserData[0].UserID); //JSON.stringify(Pusername));
        localStorage.setItem(
          "Loginusertype",
          response.data.UserData[0].UserType
        );
        if (response.data.UserData[0].UserType == "Administration") {
          navigate("/ChannelPopup");
        } else {
          navigate("/ChannelPopup");
        }
      }
    } catch (error) {
      // notifyMessage("Login Failed", "warning");
      showErrorToast("Login Failed");
    }
  };

  const or = {
    position: "relative",
    marginBottom: "10px",
    "&:before, &:after": {
      content: "''",
      display: "inline-block",
      height: "1px",
      width: "40%",
      background: "#00000044",
      position: "absolute",
      top: "50%",
    },
    "&:before": {
      transform: "translate(-70%, -50%)",
    },
    "&:after": {
      transform: "translate(70%, -50%)",
    },
  };

  const handleDownloadApk = () => {
    const link = document.createElement("a");
    link.href = tvAppUrl; // Use the variable directly, not in {}
    link.download = "TvApp.apk"; // Optional: Set a filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="logincontainer" id="container">
        <div className="toggle-container">
          <div className="toggle">
            <div className="toggle-panel toggle-right">
              <img
                width={300}
                src="https://www.hap.in/images/hap-logo.png"
                alt="img"
              />
            </div>
          </div>
        </div>
        <div className="form-container sign-in">
          <form onSubmit={handleSubmit}>
            <h1>Sign In</h1>
            <hr />
            <GoogleLogin
              onSuccess={(credentialResponse) => {
                responseGoogle(credentialResponse);
              }}
              onError={() => {}}
            />
            <br />
            <div className="separator">
              <div className="line"></div>
              <h6>or</h6>
              <div className="line"></div>
            </div>

            <input
              type="text"
              required
              id="txtbox"
              onChange={updateUsername}
              placeholder="UserName"
              autoComplete="username"
            />
            <i
              className="bx bxs-user text-dark"
              style={{
                marginRight: "auto",
                marginLeft: "20px",
                marginTop: "-35px",
              }}
            ></i>
            <i
              className="bx bxs-lock-alt text-dark"
              style={{ marginRight: "auto", marginLeft: "20px" }}
            ></i>
            <input
              type={passwordVisible ? "text" : "password"}
              onChange={updatepassword}
              required
              value={RequiredValidation}
              placeholder="Password"
              autoComplete="current-password"
            />
            <i
              className={`toggle-password text-dark fa ${
                passwordVisible ? "fa-eye" : "fa-eye-slash"
              } eye-icon`}
              style={{
                marginLeft: "auto",
                marginTop: "-35px",
                marginRight: "20px",
              }}
              onClick={togglePasswordVisibility}
            ></i>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <br />
            <span style={{ color: "red" }}>{LoginResponsemessage}</span>

            <button type="submit" onClick={handlePost}>
              Sign In
            </button>
            <br></br>
            <button
              className="TvAppApkBTn"
              title="DownloadApk"
              onClick={handleDownloadApk}
            >
              <i
                class="fa fa-download"
                style={{ fontSize: "15px" }}
                onClick={handleDownloadApk}
              ></i>
            </button>

            <div className="copyrights">
              {/* &copy; {new Date().getFullYear()} Client Linx Software Pvt Ltd.
              All rights reserved.
              <br></br> */}
              <b>Version - {packageInfo.version}</b>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
